import { useLayoutEffect, useState } from "react";
import { runWhenNoCriticalOperation } from "services/criticalOperation";

/** Keep the current route mounted while it owns an in-memory mutation identity. */
export const useMaintenanceWhenSafe = (requested: boolean) => {
  const [visible, setVisible] = useState(false);

  useLayoutEffect(() => {
    if (!requested) {
      setVisible(false);
      return;
    }

    return runWhenNoCriticalOperation(() => setVisible(true));
  }, [requested]);

  return visible;
};
